
import './App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './pages/home/Home';
import Navbar from './components/navbar/Navbar';
import Posicionamiento from './pages/posicionamiento/Posicionamiento';
import Analitica from './pages/analitica/Analitica';
import Desarrollo from './pages/desarrollo/Desarrollo';
import VisualDesign from './pages/visualdesign/VisualDesign';
import Proyectos from './pages/proyectos/Proyectos';
import ProyectosDetails from './pages/proyectosDetails/ProyectosDetails';
import Empresa from './pages/empresa/Empresa';
import Footer2 from './components/footer/Footer2';
import Cookies from './components/Cookies';


function App() {
  return (
     <>
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home}/>
        <Route path='/Posicionamiento' exact component={Posicionamiento} />
        <Route path='/Analitica' exact component={Analitica} />
        <Route path='/Desarrollo' exact component={Desarrollo} />
        <Route path='/VisualDesign' exact component={VisualDesign} />
        <Route path='/Empresa' exact component={Empresa} />
        <Route path='/Proyectos' exact component={Proyectos} />
        <Route path='/ProyectosDetails' exact component={ProyectosDetails} />
      </Switch>
      <Cookies/>
      <Footer2/>
    </Router>
    </>
  );
}

export default App;
